<template>
	<v-menu offset-y origin="left top"  transition="slide-y-transition" content-class="notification-dropdown" right nudge-top="-10" class="v-step-1 quick-link">
		<v-btn icon large slot="activator" class="my-0">
			<i class="zmdi grey--text zmdi-hc-fw font-lg zmdi-apps"></i>
		</v-btn>
		<div class="dropdown-content">
			<div class="dropdown-top d-custom-flex justify-space-between primary">
				<span class="white--text fw-bold">Quick audit</span>
			</div>
			<v-list class="dropdown-list">
				<v-list-tile >
					<i class="mr-3 ti-arrow-right primary--text"></i>
					<span>Sales: {{formatter.format(sales)}}</span>
				</v-list-tile>
				<v-list-tile >
					<i class="mr-3 ti-arrow-left warning--text"></i>
					<span>Costs: {{formatter.format(costs)}}</span>
				</v-list-tile>

				<v-list-tile >
					<i class="mr-3 ti-hand-drag primary--text"></i>
					<span>Arrangement fee: {{formatter.format(arrangementFee)}}</span>
					
				</v-list-tile>
				<v-list-tile >
					<i class="mr-3 ti-stack-overflow success--text"></i>
					<span>Sold tickets: {{ soldTickets }}</span>
					
				</v-list-tile>
			</v-list>
		</div>
	</v-menu>
</template>

<script>
	import { mapGetters } from 'vuex'
	import { getCurrentAppLayout } from 'Helpers/helpers'
	import Enumerable from 'linq'

	export default {
		data(){
			return {

			}
		},
		computed: {
			...mapGetters([
				'season',
				'reportingData'
			]),
			sales: function () {
				if (this.reportingData.length > 0 && this.season) {
					let enumerable = Enumerable
						.from(this.reportingData)
						.where(item => item['wo_status'] === 2)
		
					return enumerable
						.select(item => item['sales_total'])
						.sum()
				} else {
					return 0
				}
			},
			costs: function () {
				if (this.reportingData.length > 0 && this.season) {
					let enumerable = Enumerable
						.from(this.reportingData)
						.where(item => item['wo_status'] === 2)
		
					return enumerable
						.select(item => item['costs_total'])
						.sum()
				} else {
					return 0
				}
			},
			arrangementFee: function () {
				if (this.reportingData.length > 0 && this.season) {
					let enumerable = Enumerable
						.from(this.reportingData)
						.where(item => item['wo_status'] === 2)
		
					return enumerable
						.select(item => item['arrangement_fee'])
						.sum()
				} else {
					return 0
				}
			},
			soldTickets: function () {
				if (this.reportingData.length > 0 && this.season) {
					let enumerable = Enumerable
						.from(this.reportingData)
						.where(item => item['wo_status'] === 2)
						.where(item => item['FK_ArticleType'] === 10 || item['FK_ArticleType'] === 1 || item['FK_ArticleType'] === 2)

		
					return enumerable
						.select(item => item['Menge'])
						.sum()
				} else {
					return 0
				}
			}
		},
		methods: {
			getMenuLink(link) {
				return '/' + getCurrentAppLayout(this.$router) + link
			}
		},
		created () {
			this.formatter = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD',
				minimumFractionDigits: 2,
			})
		}
	}
</script>